import ContentWrapper from '@/components/ContentWrapper';
import ListCard from '@/components/ListCard';
import { BaseBlockComponentProps } from '@/types/block';
import { NextArray } from '@grace-studio/graceful-next/types';

type ListBlockProps = BaseBlockComponentProps<{
  items: NextArray<any>;
  heading: {
    numbers?: string;
    content?: string;
  };
}>;

const ListBlock: ListBlockProps = ({ block }) => (
  <>
    <ContentWrapper>
      <div className="grid-base mb-4 lg:mb-6">
        {block.heading.numbers && (
          <span
            className={
              block.heading.content
                ? 'col-span-2 lg:col-span-8'
                : 'col-span-full'
            }
          >
            {block.heading.numbers}
          </span>
        )}
        {block.heading.content && (
          <span className="col-span-4 col-start-3 lg:col-start-9">
            {block.heading.content}
          </span>
        )}
      </div>

      {block.items.map((item, index) => (
        <ListCard key={item._key} number={index + 1} textComponent={item} />
      ))}
    </ContentWrapper>
  </>
);

export default ListBlock;
